import React from 'react'
import { CompanyHeadings, CompanyLinksBackgroundImg, CompanyParagraphTexts, CompanyParagraphTextsLinks } from '../Blogs/CompanyLinksStyled';
import Container from 'components/layout/Container';
import Header from 'components/Header';

const TermsandServices: React.FC = () => {

    return (
        <>
            <Header />

            <CompanyLinksBackgroundImg>
                <Container>

                    <CompanyHeadings>Terms and Conditions for gamesfi.live </CompanyHeadings>
                    <CompanyParagraphTexts>
                        THESE TERMS OF SERVICE (“TERMS”) ARE A LEGAL AGREEMENT BETWEEN YOU (“YOU” OR “YOUR”) AND gamesfi.live , INX. BY DOWNLOADING, INSTALLING ANY gamesfi.live APPLICATION (THE “APPLICATION”) AND USING IT IN CONNECTION WITH OTHER SERVICES PROVIDED BY gamesfi.live: EARN REAL BITCOIN OR OTHERWISE ACCESSED THROUGH THE USE OF THE APPLICATION (SUCH SERVICES AND THE APPLICATION COLLECTIVELY, THE “SERVICE”) YOU AGREE THAT YOU HAVE READ, UNDERSTOOD, ACCEPT AND AGREE TO BE BOUND BY THESE TERMS. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT ACCESS OR OTHERWISE USE THE SERVICE. IMPORTANT NOTE:
                    </CompanyParagraphTexts>

                    <CompanyParagraphTexts>
                        These Terms contain a Dispute Resolution and Arbitration Provision, including Class Action Waiver that affects your rights under these Terms and with respect to disputes you may have with “gamesfi.live: EARN REAL BITCOIN”. You may opt out of the binding individual arbitration and class action waiver as provided below. gamesfi.live reserves the right, in its sole discretion, to modify or change these Terms at any time by posting the changes on or within the Application or other parts of the Service or on at
                        <a href='https://gamesfi.live/' target='_blank' rel="noreferrer"> https://gamesfi.live/</a>
                    </CompanyParagraphTexts>

                    <CompanyParagraphTexts>
                        Your continued use of the Service following the posting of such changes constitutes Your acceptance of the revised Terms. If the modified Terms are not acceptable to You, Your only recourse is to discontinue Your use of the Service. You agree that gamesfi.live: EARN REAL BITCOIN may change any part of the Service, including its content, at any time or discontinue the Service or any part thereof, for any reason, without notice to You and without liability.
                    </CompanyParagraphTexts>

                    <CompanyHeadings>For more details visit our Link given below :</CompanyHeadings>
                    <CompanyParagraphTextsLinks>
                        <a href='https://gamefilive.blogspot.com/2022/01/terms-and-conditions-for-crypto-tiles.html' target='blank' rel="noreferrer">https://gamefilive.blogspot.com/2022/01/terms-and-conditions-for-crypto-tiles.html</a>
                    </CompanyParagraphTextsLinks>

                </Container>
            </CompanyLinksBackgroundImg>
        </>
    )
}

export default TermsandServices;